import { type ReactNode } from 'react';
import { androidBridge, iosPostMessage } from '@hungryroot/environment';
import { EditBlock } from '@hungryroot/plan';
import { subscriptionSelectorModalData } from '../../main';

type SubscriptionContainerBlockProps = {
  className?: string;
  customerId: number;
  containerId: number;
  containerName: string;
  occasionId: number;
  occasionGroupId: number;
  icon: ReactNode;
  heading: string;
  isNew?: boolean;
  description: string;
  editDisabled?: boolean;
};

export const SubscriptionContainerBlock = ({
  className,
  containerId,
  containerName,
  occasionId,
  occasionGroupId,
  icon,
  heading,
  isNew,
  description,
  editDisabled,
}: SubscriptionContainerBlockProps) => {
  return (
    <>
      <EditBlock
        className={className}
        heading={heading}
        isNew={isNew}
        description={description}
        icon={icon}
        editDisabled={editDisabled}
        onClick={() => {
          androidBridge('showSupplementsSelector');
          iosPostMessage({ container_id: containerId });

          subscriptionSelectorModalData.set({
            containerId,
            containerName,
            occasionGroupId,
            occasionId,
          });
        }}
      />
    </>
  );
};
